module.exports = __webpack_public_path__ + "static/btn_030.bcd49f31.png";